import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { saveAs } from 'file-saver';

import { ModalContext } from '@/utils/contexts/ModalContext';

import api from '@/services/api';

import styles from '@/views/components/Modal/ModalHowToCreateSimpleTexts.module.scss';

const ModalCheckTemplateAfterSimplification = () => {
	const { dict } = useSelector((state) => state.app);

	const { menuResources } = useSelector(state => state.data);

	const { 
		closeModal,
	} = useContext(ModalContext);

	const getResourceDownload = async (resourceName) => {
		await api.get(`/resources/documentation/${resourceName}`, { responseType: 'blob' })
			.then(({headers, data}) => {
				let pdf = new Blob([ data ], {type: 'application/pdf'});
				let pdfURL = URL.createObjectURL(pdf);
				let fileName = headers["content-disposition"].split("filename=")[1];
				fileName = fileName.replaceAll('"','');
				saveAs(data, fileName);
				window.open(pdfURL, '_blank');
			});
	};

	const getResourceElement = (resource) => {
		if (resource.type === 'regulation') { return null; }

		return (
			resource.link ? (
				<p>
					<a
						className={ styles['how-to__more-info--link'] } 
						href={ resource.link }
						target="_blank"
						rel="noreferrer"
					>
						{ resource.label }&nbsp;
						<i
							className='icon-external'
							style={ {fontSize: "16px"} }
						/>
					</a>
				</p>
			) : (
				<p
					className={ styles['how-to__more-info--link'] } 
					role="button"
					tabIndex={ 0 }
					onClick={ () => getResourceDownload(resource.type) }
				>
					{ resource.label }&nbsp;
					<i
						className='icon-download'
						style={ {fontSize: "16px"} }
					/>
				</p>
			)
		);
	};

	return (
		<div className='modal__content'>
			<div className={ styles['how-to--container'] }>
				<h3 className={ styles['how-to--title'] }>
					{ dict.modals.howToCreateSimpleTexts.head }
				</h3>
				<div 
					onClick={ () => { closeModal(); } } 
					className={ styles['how-to--close'] }
				>
					<i className='icon-close' />
				</div>

				<p>{ dict.modals.howToCreateSimpleTexts.listStart }</p>
				<ol className={ styles['how-to--list'] }>
					<li>{ dict.modals.howToCreateSimpleTexts.list1 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list2 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list3 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list4 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list5 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list6 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list7 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list8 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list9 }</li>
					<li>{ dict.modals.howToCreateSimpleTexts.list10 }</li>
				</ol>
				<div className={ styles['how-to__more-info'] }>
					<p>{ dict.modals.howToCreateSimpleTexts.moreTips }</p>
					{menuResources && menuResources.map((resource) => getResourceElement(resource))}
				</div>
			</div>
		</div>
	);
};

export default ModalCheckTemplateAfterSimplification;